import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import NavBar from '../components/Navbar/Navbar';

export default function RootLayout() {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'static',
          width: '100%',
          backgroundColor: '#fff',
          flexShrink: 0,
        }}
      >
        <NavBar />
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          backgroundColor: '#fff',
          overflow: 'auto',
          msOverflowStyle: 'none',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
